<div class=" p-mr-4 p-p-3 p-d-flex p-flex-row">
  <i
    class="fa-thin fa-folder-magnifying-glass"
    style="font-size: 120px; margin-top: 8px"
  ></i>
  <h4 style="margin-left: 20px; margin-top: 58px">{{title}}</h4>
</div>
